import { fork, take, takeEvery, call, put, all } from "redux-saga/effects";

import {
  getCourseCategoriesResponse,
  getProductCategoriesResponse,
  getCoursesListingResponse,
  getModuleListingResponse,
  getModuleNotesGetResponse,
  getModuleNotesUpdateResponse,
  getModuleNotesDeleteResponse,
  getModuleFavGetResponse,
  getModuleFavDeleteResponse,
  getFavoriteCoursesResponse,
  getUserCoursesResponse,
  setFavoriteCoursesResponse,
  removeFavoriteCoursesResponse,
  // Action Path
  getLearningPathResponse,
  // Action Path Broker
  getLearningPathBrokerResponse,
  getCoursesListingResponseFromWoo,
  getCoursesListingResponseFromBroker,
  getCoursesCategoriesResponseFromBroker,
  getModuleListingResponseBroker,

  // Assign Course
  getAssignCourseResponse,
  getAssignBrokerCourseResponse,
  getInProgressBrokerResponse,

  // My Courses
  getMyCoursesResponse,
  getMyLearningPathsResponse,

  // Code of Ethics
  getCodeOfEthicsResponse,
  postEthicsAgreeCheckResponse,
  markModuleProgressResponse,
  getLevelDetailResponse,
  setMarkViewResponse,
  getCheckListInsertResponse,
  getLPUnAssignedResponse,
  getProductCategoriesDataResponse,
  getSubProductCategoriesDataResponse,
  getSingleLPResponse,
  getCourseRelatedResponse,
  getVideoProductCategoriesResponse,
  getUnAssginedOBLPResponse,
  getAssignBrokerCourseResponseLP,
  getPopularCoursesResponse,
  getUsefulCoursesResponse,
  getPopularFreeCoursesResponse,
  getCoursesWithPaidSubscriptionResponse,
  getCoursesWithHigherSubscriptionResponse,
  getCourseDetailEcomResponse,
  getCategoryListNewResponse,
  getGlobalSearchCoursesResponse,
  getUpcomingCoursesResponse,
  getTagsResponse,
  deleteCoachResponse,
  getRankStatusResponse,
  getDynamicTextResponse,
  getActivityRingResponse,
  getForYouDataResponse,
  getRecommendIdsResponse,
  saveAnswersResponse,
} from "./actions";
import types from "./types";
import { getUserCourses } from "../../api/courses";
import {
  apiDirect,
  getAPI,
  newAPICall,
  postAPI,
  postAPIWithoutModule,
} from "../../api/generic";

export function* doGetUserCourses() {
  while (true) {
    const { payload } = yield take(types.USER_COURSES);
    const response = yield call(getUserCourses, payload);
    yield put(getUserCoursesResponse(response));
  }
}

export function* doInProgressCoursesBroker() {
  while (true) {
    const { payload } = yield take(types.IN_PROGRESS_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getInProgressBrokerResponse(response));
  }
}

export function* doGetCourseCategories() {
  while (true) {
    const { payload } = yield take(types.COURSE_CATEGORIES);
    const response = yield call(getAPI, payload);
    yield put(getCourseCategoriesResponse(response));
  }
}

export function* doGetProductCategories() {
  while (true) {
    const { payload } = yield take(types.PRODUCT_CATEGORIES);
    const response = yield call(getAPI, payload);
    yield put(getProductCategoriesResponse(response));
  }
}

export function* doGetVideoProductCategories() {
  while (true) {
    const { payload } = yield take(types.VIDEO_PRODUCT_CATEGORIES);
    const response = yield call(getAPI, payload);
    yield put(getVideoProductCategoriesResponse(response));
  }
}

export function* doGetForYouData() {
  while (true) {
    const { payload } = yield take(types.FOR_YOU_DATA);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getForYouDataResponse(response));
  }
}

export function* doGetProductCategoriesData() {
  while (true) {
    const { payload } = yield take(types.PRODUCT_CATEGORIES_DATA);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getProductCategoriesDataResponse(response));
  }
}

export function* doGetSubProductCategoriesData() {
  while (true) {
    const { payload } = yield take(types.PRODUCT_SUB_CATEGORIES_DATA);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSubProductCategoriesDataResponse(response));
  }
}

export function* doGetCoursesListing() {
  while (true) {
    const { payload } = yield take(types.COURSES_LISTING);
    const response = yield all([
      yield call(getAPI, payload.ecom),
      yield call(postAPIWithoutModule, payload.broker),
    ]);
    yield put(getCoursesListingResponse(response));
  }
}
export function* doGetModuleListing() {
  while (true) {
    const { payload } = yield take(types.MODULE_LISTING);
    console.log("Xsel Module Listing", payload);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getModuleListingResponse(response));
  }
}
export function* doGetModuleNotesGet() {
  while (true) {
    // console.log('Saga getNotes')
    const { payload } = yield take(types.MODULE_NOTES_GET);
    const response = yield call(postAPI, payload);
    yield put(getModuleNotesGetResponse(response));
  }
}
export function* doGetModuleNotesUpdate() {
  while (true) {
    const { payload } = yield take(types.MODULE_NOTES_UPDATE);
    const response = yield call(postAPI, payload);
    yield put(getModuleNotesUpdateResponse(response));
  }
}
export function* doGetModuleNotesDelete() {
  while (true) {
    const { payload } = yield take(types.MODULE_NOTES_DELETE);
    const response = yield call(postAPI, payload);
    yield put(getModuleNotesDeleteResponse(response));
  }
}
export function* doGetModuleFavGet() {
  while (true) {
    const { payload } = yield take(types.MODULE_FAV_GET);
    const response = yield call(postAPI, payload);
    yield put(getModuleFavGetResponse(response));
  }
}
export function* doGetModuleFavDelete() {
  while (true) {
    const { payload } = yield take(types.MODULE_FAV_DELETE);
    const response = yield call(postAPI, payload);
    yield put(getModuleFavDeleteResponse(response));
  }
}

export function* doGetFavoriteCoursesList() {
  while (true) {
    const { payload } = yield take(types.FAVORITE_COURSES);
    const response = yield call(getAPI, payload);
    yield put(getFavoriteCoursesResponse(response));
  }
}

export function* doSetFavoriteCourse() {
  while (true) {
    const { payload } = yield take(types.SET_FAVORITE_COURSES);
    const response = yield call(postAPI, payload, true);
    yield put(setFavoriteCoursesResponse(response));
  }
}

export function* doRemoveFavoriteCourse() {
  while (true) {
    const { payload } = yield take(types.REMOVE_FAVORITE_COURSES);
    const response = yield call(postAPI, payload, true);
    yield put(removeFavoriteCoursesResponse(response));
  }
}

export function* doGetLearningPath() {
  while (true) {
    const { payload } = yield take(types.LEARNING_PATH);
    const response = yield call(getAPI, payload);
    yield put(getLearningPathResponse(response));
  }
}

export function* doGetLearningPathBroker() {
  while (true) {
    const { payload } = yield take(types.LEARNING_PATH_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLearningPathBrokerResponse(response));
  }
}

export function* doGetUnAssignedOBLP() {
  while (true) {
    const { payload } = yield take(types.UNASSIGNED_OBLP);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUnAssginedOBLPResponse(response));
  }
}

export function* doGetCoursesListingWoo() {
  while (true) {
    const { payload } = yield take(types.COURSES_LISTING_WOO);
    const response = yield call(getAPI, payload);
    yield put(getCoursesListingResponseFromWoo(response));
  }
}

export function* doGetCoursesCategoriesBroker() {
  while (true) {
    const { payload } = yield take(types.COURSES_CATEGORIES_BROKER);
    const response = yield call(getAPI, payload);
    yield put(getCoursesCategoriesResponseFromBroker(response));
  }
}

export function* doGetCoursesListingBroker() {
  while (true) {
    const { payload } = yield take(types.COURSES_LISTING_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoursesListingResponseFromBroker(response));
  }
}

export function* doGetModuleListingBroker() {
  while (true) {
    const { payload } = yield take(types.MODULES_LISTING_BROKER);
    console.log("Module Listing Broker", payload);
    const response = yield call(getAPI, payload);
    yield put(getModuleListingResponseBroker(response));
  }
}

export function* doGetAssignCourse() {
  while (true) {
    const { payload } = yield take(types.ASSIGN_COURSE);
    console.log("Assign Course", payload);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAssignCourseResponse(response));
  }
}

export function* doGetAssignBrokerCourse() {
  while (true) {
    const { payload } = yield take(types.ASSIGN_COURSE_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAssignBrokerCourseResponse(response));
  }
}

export function* doGetAssignBrokerCourseLP() {
  while (true) {
    const { payload } = yield take(types.ASSIGN_COURSE_BROKERLP);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAssignBrokerCourseResponseLP(response));
  }
}

export function* doGetMyCourses() {
  while (true) {
    const { payload } = yield take(types.MY_COURSES);
    // const response = yield call(postAPIWithoutModule, payload)
    const response = yield all([
      call(postAPIWithoutModule, payload.ecom),
      call(postAPIWithoutModule, payload.broker),
    ]);
    yield put(getMyCoursesResponse(response));
  }
}

export function* doGetMyLearningPath() {
  while (true) {
    const { payload } = yield take(types.MY_LEARNING_PATHS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getMyLearningPathsResponse(response));
  }
}

export function* doGetCodeOfEthics() {
  while (true) {
    const { payload } = yield take(types.MASTER_CODE_OF_ETHICS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCodeOfEthicsResponse(response));
  }
}
//TODO:
export function* doPostCodeOfEthicsAgree() {
  while (true) {
    const { payload } = yield take(types.ETHICS_AGREE_CHECK);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(postEthicsAgreeCheckResponse(response));
  }
}

export function* doMarkModuleProgress() {
  while (true) {
    const { payload } = yield take(types.MARK_MODULE_PROGRESS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(markModuleProgressResponse(response));
  }
}

export function* doGetRecommendIds() {
  while (true) {
    const { payload } = yield take(types.RECOMMEND_IDS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getRecommendIdsResponse(response));
  }
}

export function* doSaveAnswers() {
  while (true) {
    const { payload } = yield take(types.SAVE_ANSWERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(saveAnswersResponse(response));
  }
}

export function* doGetLevelDetail() {
  while (true) {
    const { payload } = yield take(types.GET_LEVEL_DETAIL_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLevelDetailResponse(response));
  }
}

export function* doSetMarkView() {
  while (true) {
    const { payload } = yield take(types.MARK_VIEW);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(setMarkViewResponse(response));
  }
}

export function* doCheckListInsert() {
  yield takeEvery(types.CHECKLIST_INSERT, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCheckListInsertResponse(response));
  });
}

export function* doGetLPUnAssigned() {
  yield takeEvery(types.LEARNING_PATHS_UNASSIGNED, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLPUnAssignedResponse(response));
  });
}

export function* doGetSingleLPData() {
  yield takeEvery(types.SINGLE_LP_DATA, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSingleLPResponse(response));
  });
}

export function* doGetCourseRelatedData() {
  yield takeEvery(types.COURSE_RELATED, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCourseRelatedResponse(response));
  });
}

export function* doGetPopularCoursesData() {
  yield takeEvery(types.POPULAR_COURSES, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getPopularCoursesResponse(response));
  });
}

export function* doGetUsefulCoursesData() {
  yield takeEvery(types.USEFUL_COURSES, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUsefulCoursesResponse(response));
  });
}

export function* doGetPopularFreeCoursesData() {
  yield takeEvery(types.POPULAR_FREE_COURSES, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getPopularFreeCoursesResponse(response));
  });
}

export function* doGetCoursesWithPaidSubscriptionData() {
  yield takeEvery(
    types.COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION,
    function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getCoursesWithPaidSubscriptionResponse(response));
    }
  );
}

export function* doGetCoursesWithHigherSubscriptionData() {
  yield takeEvery(
    types.COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION,
    function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getCoursesWithHigherSubscriptionResponse(response));
    }
  );
}

export function* doGetCourseDetailEcom() {
  yield takeEvery(
    types.COURSE_DETAIL_ECOM,
    function* ({ payload }) {
      const response = yield call(apiDirect, payload);
      yield put(getCourseDetailEcomResponse(response));
    }
  );
}

export function* doGetCategoryListNew() {
  yield takeEvery(
    types.GET_CATEGORY_LIST_NEW_REQ,
    function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getCategoryListNewResponse(response));
    }
  )
}

export function* doGetGlobalSearchCourses() {
  yield takeEvery(
    types.GLOBAL_SEARCH_COURSES,
    function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getGlobalSearchCoursesResponse(response));
    }
  );
}

export function* doGetUpcomingCourses() {
  yield takeEvery(types.GET_UPCOMING_COURSES, function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getUpcomingCoursesResponse(response));
  })
}

export function* doGetTagsData() {
  yield takeEvery(types.TAGS, function* ({ payload }) {
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTagsResponse(response));
  });
}

export function* doDeleteCoach() {
  yield takeEvery(types.DELETE_CAOCH_REQ, function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(deleteCoachResponse(response));
  })
}

export function* doGetRankStatus() {
  yield takeEvery(types.RANK_STATUS, function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getRankStatusResponse(response));
  })
}

export function* doGetDynamicText() {
  yield takeEvery(types.DYNAMIC_TEXT, function* ({ payload }) {
    const response = yield call(getAPI, payload);
    yield put(getDynamicTextResponse(response));
})
}

export function* doGetActivityRing() {
  yield takeEvery(types.ACTIVITY_RING, function* ({ payload }) {
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getActivityRingResponse(response));
  })
}

function* courses() {
  yield fork(doGetUserCourses);
  yield fork(doInProgressCoursesBroker);
  yield fork(doGetCourseCategories);
  yield fork(doGetProductCategories);
  yield fork(doGetVideoProductCategories);
  yield fork(doGetCoursesListing);
  yield fork(doGetModuleListing);
  yield fork(doGetModuleNotesGet);
  yield fork(doGetModuleNotesUpdate);
  yield fork(doGetModuleNotesDelete);
  yield fork(doGetModuleFavGet);
  yield fork(doGetModuleFavDelete);
  yield fork(doGetFavoriteCoursesList);
  yield fork(doSetFavoriteCourse);
  yield fork(doRemoveFavoriteCourse);
  yield fork(doGetLearningPath);
  yield fork(doGetLearningPathBroker);
  yield fork(doGetUnAssignedOBLP);
  yield fork(doGetCoursesListingWoo);
  yield fork(doGetCoursesListingBroker);
  yield fork(doGetCoursesCategoriesBroker);
  yield fork(doGetModuleListingBroker);
  yield fork(doGetAssignCourse);
  yield fork(doGetAssignBrokerCourse);
  yield fork(doGetAssignBrokerCourseLP);
  yield fork(doGetMyCourses);
  yield fork(doGetMyLearningPath);
  yield fork(doGetCodeOfEthics);
  yield fork(doPostCodeOfEthicsAgree);
  yield fork(doGetRecommendIds);
  yield fork(doMarkModuleProgress);
  yield fork(doGetLevelDetail);
  yield fork(doSetMarkView);
  yield fork(doCheckListInsert);
  yield fork(doGetLPUnAssigned);
  yield fork(doGetProductCategoriesData);
  yield fork(doGetSubProductCategoriesData);
  yield fork(doGetSingleLPData);
  yield fork(doGetCourseRelatedData);
  yield fork(doGetPopularCoursesData);
  yield fork(doGetUsefulCoursesData);
  yield fork(doGetPopularFreeCoursesData);
  yield fork(doGetCoursesWithPaidSubscriptionData);
  yield fork(doGetCoursesWithHigherSubscriptionData);
  yield fork(doGetCourseDetailEcom);
  yield fork(doGetCategoryListNew);
  yield fork(doGetGlobalSearchCourses)
  yield fork(doGetUpcomingCourses)
  yield fork(doGetTagsData)
  yield fork(doDeleteCoach)
  yield fork(doGetRankStatus)
  yield fork(doGetDynamicText)
  yield fork(doGetActivityRing)
  yield fork(doGetForYouData);
  yield fork(doSaveAnswers);
}
export default courses;
